import http from '@/http'

export function get(params) {
  return http.get('/user/address', {
    loading: true,
    params
  })
}

export function put(data) {
  return data.id ? http.put('/user/address/' + data.id, data) : http.post('/user/address', data)
}

export function del(id) {
  return http.delete('/user/address/' + id)
}